import { render, staticRenderFns } from "./trendsDialog.vue?vue&type=template&id=47235012&scoped=true"
import script from "./trendsDialog.vue?vue&type=script&lang=js"
export * from "./trendsDialog.vue?vue&type=script&lang=js"
import style0 from "./trendsDialog.vue?vue&type=style&index=0&id=47235012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47235012",
  null
  
)

export default component.exports